import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { AlertsFeedView } from './pages/AlertsFeedView.js';
import { AnalysisDebugView } from './pages/AnalysisDebugView.js';
import { AnalysisView } from './pages/AnalysisView';
import { AssetsView } from './pages/AssetsView.js';
import { AssetView } from './pages/AssetView.js';
import { Dashboard } from './pages/Dashboard';
import { DevelopmentView } from './pages/DevelopmentView.js';
import { DomainsView } from './pages/DomainsView.js';
import { DomainView } from './pages/DomainView.js';
import { ErrorPage } from './pages/ErrorPage';
import { IncidentList } from './pages/IncidentList.js';
import { JobsView } from './pages/JobsView.js';
import { Login } from './pages/Login';
import { Logout } from './pages/Logout';
import { MainView } from './pages/MainView';
import { ProjectsView } from './pages/ProjectsView';
import { ProjectView } from './pages/ProjectView';
import { RootsView } from './pages/RootsView.js';
import { RootView } from './pages/RootView.js';
import { RulesView, RuleView } from './pages/RuleView.js';
import { SnapshotView } from './pages/SnapshotView';
import { TestRunsView } from './pages/TestRunsView.js';
import { TestsView } from './pages/TestsView.js';
import { TestView } from './pages/TestView';
import { SchedulerView } from './pages/SchedulerView.js';
import { WorkersView, WorkerView } from './pages/WorkersView.js';
import { useAuth } from './providers/AuthProvider';
import { ServiceProvider } from './providers/ServiceProvider';

// Create public routes
const publicRouter = createBrowserRouter([
  {
    path: '/',
    element: <Login />
  },
  {
    path: '*',
    element: <Navigate to="/" />
  }
]);

// Create protected routes.
const protectedRouter = createBrowserRouter([
  {
    path: '/',
    element: <Dashboard />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/',
        element: <MainView />
      },
      {
        path: '/logout',
        element: <Logout />
      },
      {
        path: '/jobs',
        element: <JobsView />
      },
      {
        path: '/test-runs',
        element: <TestRunsView />
      },
      {
        path: '/workers',
        element: <WorkersView />
      },
      {
        path: '/scheduler',
        element: <SchedulerView />
      },
      {
        path: '/workers/:workerId',
        element: <WorkerView />
      },
      {
        path: '/projects',
        element: <ProjectsView />
      },
      {
        path: '/projects/:projectId',
        element: <ProjectView />
      },
      {
        path: '/projects/:projectId/snapshots/:snapshotType/:snapshotId',
        element: <SnapshotView />
      },
      {
        path: '/projects/:projectId/analyses/:analysisType/:analysisId',
        element: <AnalysisView />
      },
      {
        path: '/projects/:projectId/analyses/:analysisType/:analysisId/debug',
        element: <AnalysisDebugView />
      },
      {
        path: '/projects/:projectId/tests',
        element: <TestsView />
      },
      {
        path: '/projects/:projectId/tests/:testId',
        element: <TestView />
      },
      {
        path: '/projects/:projectId/assets',
        element: <AssetsView />
      },
      {
        path: '/projects/:projectId/assets/:assetId',
        element: <AssetView />
      },
      {
        path: '/projects/:projectId/roots',
        element: <RootsView />
      },
      {
        path: '/projects/:projectId/roots/:rootId',
        element: <RootView />
      },
      {
        path: '/projects/:projectId/domains',
        element: <DomainsView />
      },
      {
        path: '/projects/:projectId/domains/:domainId',
        element: <DomainView />
      },
      {
        path: '/alerts',
        element: <AlertsFeedView />
      },
      {
        path: '/incidents',
        element: <IncidentList />
      },
      {
        path: '/rules',
        element: <RulesView />
      },
      {
        path: '/rules/:ruleId',
        element: <RuleView />
      },
      {
        path: '/development',
        element: <DevelopmentView />
      }
    ]
  }
]);

export function Routes() {
  const { authenticated } = useAuth();
  if (!authenticated) {
    return <RouterProvider router={publicRouter} />;
  }

  return (
    <ServiceProvider>
      <RouterProvider router={protectedRouter} />
    </ServiceProvider>
  );
}
